<template>
    <div class="d-flex">
        <b-button
            class="white-icon-button"
            :class="dynamicBtnClasses"
            @click="changeView(1)"
            :disabled="GET_GRID_VIEW === 1"
        >
            <svg width="16" aria-hidden="true" focusable="false" data-prefix="far" data-icon="square" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-square fa-w-14">
                <path fill="currentColor" d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z" class=""></path>
            </svg>
        </b-button>
        <b-button
            class="white-icon-button"
            :class="dynamicBtnClasses"
            @click="changeView(2)"
            :disabled="GET_GRID_VIEW === 2"
        >
            <svg width="20" aria-hidden="true" focusable="false" data-prefix="far" data-icon="th-large" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-th-large fa-w-16">
                <path fill="currentColor" d="M0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80zm232 0v152H48V86a6 6 0 0 1 6-6h178zM48 280h184v152H54a6 6 0 0 1-6-6V280zm232 152V280h184v146a6 6 0 0 1-6 6H280zm184-200H280V80h178a6 6 0 0 1 6 6v146z" class=""></path>
            </svg>
        </b-button>
        <b-button
            class="white-icon-button"
            :class="dynamicBtnClasses"
            @click="changeView(3)"
            :disabled="GET_GRID_VIEW === 3"
        >
            <svg width="20" aria-hidden="true" focusable="false" data-prefix="far" data-icon="th" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-th fa-w-16">
                <path fill="currentColor" d="M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM197.3 72h117.3v96H197.3zm0 136h117.3v96H197.3zm-40 232H52c-6.6 0-12-5.4-12-12v-84h117.3zm0-136H40v-96h117.3zm0-136H40V84c0-6.6 5.4-12 12-12h105.3zm157.4 272H197.3v-96h117.3v96zm157.3 0H354.7v-96H472zm0-136H354.7v-96H472zm0-136H354.7V72H472z" class=""></path>
            </svg>
        </b-button>
    </div>
</template>

<script>
    // import {BIcon} from 'bootstrap-vue';
    // import SvgIcon from '../shared/SvgIcon';
    // import {getKey} from "../../utils/common";
    // import ChartBaseItemMixin from "../../mixins/ChartBaseItemMixin";
    import {
        SET_GRID_VIEW
    } from "../../store/actions/dashboard";
    import { mapActions} from "vuex";
    import {mapGetters} from "vuex";
    import {
        GET_GRID_VIEW
    } from "../../store/actions/sensors";
    /**
     * Custom wrapper for button. Can have an icon
     * and optional / hide-able text on mobile.
     * Has active / inactive status.
     * Can be referenced with ref as to be used by
     * the parent.
     */

    export default {
        name: "GridViewSwitcher",
        // mixins: [ ChartBaseItemMixin],
        components: {
            
        },
        props: {
            icon: {
                type: String,   //b-icon svg name
                required: false
            },
            text: {
                type: String,   // btn text
                required: false
            },
            hideTextMobile: {
                type: Boolean,  // hide text on small screens
                default: false
            },
            emitThis: {
                type: String,   // emit event, handled then in parent, no func passes
                required: false
            },
            tooltip: {
                type: String,   // show tooltip
                default: ''
            },
            tooltipPlacement: {
                type: String,
                default: 'top'
            },
            active: {
                type: Boolean,  // is it active (purple), css class
                default: false
            },
            disabled: {
                type: Boolean,  // if disabled (loading)
                default: false
            },
            isBootstrapIcon: {
                type: Boolean,
                default: false
            },
            size: {
                type: String,   // large or small
                default: "large"
            },
            href: {
                type: String,
                default: null
            },
            customSpacing: {
                type: String,
                default: "mx-1 mx-sm-2 my-2 b-0 py-2"
            }
        },
        data() {
            return {
                // id: getKey(),
                minSize: 10,
                maxSize: 18,
                gridView: 2
            }
        },
        mounted () {
            this.id = this._uid;
        },
        computed: {
            dynamicBtnClasses() {
                let classes = [];

                // icon class
                 if (!this.text) {
                     classes.push('only-icon');
                 }
                 else if (this.hideTextMobile) {
                     classes.push('only-icon-mobile');
                 }

                 // is it active and purple?
                if (this.active) {
                    classes.push('active-purple');
                }

                // is it small or large
                if (this.size === 'large') {
                    classes.push('d-large-btn');
                }
                else if (this.size === 'small') {
                    classes.push('d-small-btn');
                }

                // spacing utilities override
                classes.push(this.customSpacing);

                return classes;
            },
            ...mapGetters([ GET_GRID_VIEW]),
        },
        methods: {
            ...mapActions([
                SET_GRID_VIEW
            ]),
            eventEmitter() {
                if (this.emitThis) {
                    this.$emit(this.emitThis);
                }

            },
            changeView(item) {
                this.$store.dispatch('SET_GRID_VIEW', item)
            }
            
        }
    }
</script>

<style lang="scss" scoped>
    @import "src/assets/scss/variables";

    .white-icon-button {
        background: $whiteColor 0% 0% no-repeat padding-box;
        box-shadow: 0px 2px 6px $darkBlueShadow;
        border-radius: 5px;
        border-color: $lightGrey;
        opacity: 1;
        // flex
        display: flex;
        justify-content: center;
        align-items: center;
        color: $darkBlueShadow;
        &:active {
            color: $whiteColor;
            background-color: $darkBlueShadow ;
            border-color: $lightGrey;
            &:focus {
                box-shadow: none !important;
                outline: none !important;
            }
        }
        &:hover {
            outline: 0;
            box-shadow: 0 3px 7px 0 $darkBlueShadow, 0 3px 7px 0 $darkBlueShadow;
        }
        &.only-icon {
            padding: 0;
            &.d-large-btn {
                width: 36px;
                height: 36px;
            }
            &.d-small-btn {
                width: 27px;
                height: 27px;
            }
        }

        .i-button-icon {
            color: $purpleColor !important;
            opacity: 1;
        }
        .i-button-text {
            text-align: left;
            font: normal normal normal 14px/14px Nunito, sans-serif;
            letter-spacing: 0px;
            color: $blackColor;
            opacity: 1;
        }
        /* Set active class by reversing colors, need to override previous styles */
        &.active-purple {
            background-color: $purpleColor;
            border-color: $purpleColor;
            .i-button-icon {
                color: $whiteColor !important;
            }
            .i-button-text {
                color: $whiteColor !important;
            }

            svg {
                filter: brightness(2);
            }
        }

        &.disabled {
            background-color: $purpleColor;
            box-shadow: none;
            color: $whiteColor;

            &:hover {
                box-shadow: none;
            }
        }
    }

    /*@media screen and (max-width: 762px) {*/
    /*    .white-icon-button {*/
    /*        &.only-icon-mobile {*/
    /*            padding: 0;*/
    /*            min-width: 36px;*/
    /*            min-height: 36px;*/
    /*        }*/
    /*    }*/
    /*}*/
</style>